import React from 'react';
// import { Button } from '@material-ui/core';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

// eslint-disable-next-line react/prop-types
function LoginButton({ onClick }) {
  const { loginWithRedirect } = useAuth0();

  const onClickButton = (e) => {
    // Copiar un pequeño snapshot del evento: los SyntheticEvents son "pooled"
    // y sus propiedades pueden limpiarse después del handler. Mejor pasar
    // solo lo necesario al callback del padre.
    const eventSnapshot = {
      type: e.type,
      timeStamp: e.timeStamp,
      tagName: e.currentTarget?.tagName,
    };

    // Iniciar flujo de login. No await porque normalmente redirige fuera
    // de la app y no necesitas seguir ejecutando código después.
    loginWithRedirect({ prompt: 'login' }).catch((err) => console.error('loginWithRedirect error', err));

    if (onClick) {
      onClick(eventSnapshot);
    }
  };

  return (
    <Button onClick={onClickButton}>Login</Button>
  );
}

export default LoginButton;
